
 
export const FETCH_FINANCIAL_INSTITUTIONS_REQUEST = 'financialInstitution/FETCH_FINANCIAL_INSTITUTIONS_REQUEST';
export const FETCH_FINANCIAL_INSTITUTIONS_SUCCESS = 'financialInstitution/FETCH_FINANCIAL_INSTITUTIONS_SUCCESS';
export const FETCH_FINANCIAL_INSTITUTIONS_FAILURE = 'financialInstitution/FETCH_FINANCIAL_INSTITUTIONS_FAILURE';

 
export const FETCH_FINANCIAL_INSTITUTION_REQUEST = 'financialInstitution/FETCH_FINANCIAL_INSTITUTION_REQUEST';
export const FETCH_FINANCIAL_INSTITUTION_SUCCESS = 'financialInstitution/FETCH_FINANCIAL_INSTITUTION_SUCCESS';
export const FETCH_FINANCIAL_INSTITUTION_FAILURE = 'financialInstitution/FETCH_FINANCIAL_INSTITUTION_FAILURE';

 
export const DELETE_FINANCIAL_INSTITUTION_REQUEST = 'financialInstitution/DELETE_FINANCIAL_INSTITUTION_REQUEST';
export const DELETE_FINANCIAL_INSTITUTION_SUCCESS = 'financialInstitution/DELETE_FINANCIAL_INSTITUTION_SUCCESS';
export const DELETE_FINANCIAL_INSTITUTION_FAILURE = 'financialInstitution/DELETE_FINANCIAL_INSTITUTION_FAILURE';

 
export const CREATE_FINANCIAL_INSTITUTION_REQUEST = 'financialInstitution/CREATE_FINANCIAL_INSTITUTION_REQUEST';
export const CREATE_FINANCIAL_INSTITUTION_SUCCESS = 'financialInstitution/CREATE_FINANCIAL_INSTITUTION_SUCCESS';
export const CREATE_FINANCIAL_INSTITUTION_FAILURE = 'financialInstitution/CREATE_FINANCIAL_INSTITUTION_FAILURE';

 
export const UPDATE_FINANCIAL_INSTITUTION_REQUEST = 'financialInstitution/UPDATE_FINANCIAL_INSTITUTION_REQUEST';
export const UPDATE_FINANCIAL_INSTITUTION_SUCCESS = 'financialInstitution/UPDATE_FINANCIAL_INSTITUTION_SUCCESS';
export const UPDATE_FINANCIAL_INSTITUTION_FAILURE = 'financialInstitution/UPDATE_FINANCIAL_INSTITUTION_FAILURE';


export const UPDATE_FIELD = 'financialInstitution/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'financialInstitution/SET_DEFAULT_DATA';
